import { render, staticRenderFns } from "./freightsolution-mapping.vue?vue&type=template&id=73d21f86&scoped=true"
import script from "./freightsolution-mapping.vue?vue&type=script&lang=js"
export * from "./freightsolution-mapping.vue?vue&type=script&lang=js"
import style0 from "./freightsolution-mapping.vue?vue&type=style&index=0&id=73d21f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d21f86",
  null
  
)

export default component.exports